/**
 * Bundled snapshots for ad-entry screens that must paint without waiting on Firestore.
 * Refresh from Firestore in the background; update this file if admin content changes.
 */
export const WHO_CHECKPOINT_SNAPSHOT = {
  id: 'f9PTMttLVZCok0zY6DoY',
  key: 'who',
  type: 'which_are_you',
  required: true,
  isActive: true,
  content: {
    text: '',
    ctaText: 'Continue',
  },
  nextScreen: 'name',
  conversionConfig: {
    enabled: true,
    trigger: 'load',
    value: '0',
    currency: 'USD',
    usePaymentAmount: false,
    meta: {
      enabled: true,
      eventName: 'Who',
      testEventCode: '',
    },
    google: {
      enabled: true,
      conversionActionId: '7701187191',
      validateOnly: false,
    },
    linkedin: {
      enabled: true,
      conversionRuleUrn: '27300348',
    },
  },
};

/** Labels from configuration/types — used by WhichAreYouScreen */
export const TYPES_CONFIG_SNAPSHOT = [
  'Startup founder',
  'Small business owner',
  'Corporate executive',
  'Team leader',
  'Artist or entertainer',
  'Scientist or professor',
  'Public speaker, author or influencer',
  'Explorer or professional athlete',
];

export const AD_ENTRY_CHECKPOINT_KEYS = new Set(['who']);

export const getAdEntryCheckpointSnapshot = (key) => {
  if (key === 'who') {
    return { ...WHO_CHECKPOINT_SNAPSHOT, content: { ...WHO_CHECKPOINT_SNAPSHOT.content } };
  }
  return null;
};

export const getTypesSnapshotItems = () =>
  TYPES_CONFIG_SNAPSHOT.map((label, index) => ({
    id: `item_${index}`,
    label,
  }));
